export {
  ConfirmDialog,
  DestroyDialog,
  FullscreenDialog,
  GenericDialog,
  GridFormDialog,
  InformationDialog,
  SimpleFormDialog,
  type ConfirmDialogProps,
  type DestroyDialogProps,
  type FullscreenDialogProps,
  type GenericDialogProps,
  type GridFormDialogProps,
  type InformationDialogProps,
  type SimpleFormDialogProps,
} from "./standard-dialogs"
export { CustomDialog } from "./custom-dialog"
